<style>
    .print-step-vertical-line {
        background-color: #4547BF;
        border: 3px solid #4547BF;
        width: 0 !important;
        height: 10000px !important;
    }
    .text-brown{
        color: #303030;
    }
    .circle-icon{
        -webkit-print-color-adjust: exact;
    }
</style>
<template>
    <div class="row">
        <div class="col-12">
            <div class="row step">
                <div class="col-2 overflow-hidden position-relative">
                    <div class="time d-flex float-right d-inline align-items-center justify-content-end">
                        <div class="hour">
                            <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2">
                                <svg-icon class="mb-1" v-if="showAs !== 'collapse'" name="clock" width="15" color="black"/>
                                <span v-if="showAs !== 'collapse'" class="ml-1">{{departure}}</span>
                                <span v-else class="align-self-center ml-1">+{{ step.step_count }}</span>
                            </div>
                        </div>
                        <div class="circle-icon d-inline-block ml-2 cursor-pointer">
                            <svg-icon v-if="showAs !== 'collapse'" class="circle-icon-svg" :name="icon.name" height="auto" width="15"/>
                            <svg-icon v-else name="three-dots" class="circle-icon-svg" height="auto" width="20"/>
                        </div>
                    </div>
                    <div v-if="position !== 'last'" class="vertical-line print-step-vertical-line position-absolute"></div>
                </div>
                <div v-if="showAs === 'step'" class="col-10 pl-0">
                    <div class="details">
   <!--                      <div class="hour col-4 pl-0 d-lg-none">
                            <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                                <svg-icon name="clock" width="15" color="black"/>
                                <span class="align-self-center ml-1">{{departure}}</span>
                            </div>
                        </div> -->
                        <div class="card mt-2">
                            <div class="card-body">
                                <h2 class="fw-normal">{{ step.description }}</h2>
                                <span>{{ duration.format("h[hrs] m[m]") }} | {{ step.distance.text }} | {{ step.elevationHighest }} {{ step.elevationLowest }} </span>
                            </div>

                            <div class="card-footer text-muted border-0 py-0 text-right cursor-pointer step-footer">
                                <span class="float-left cost-colour">
                                    <h2 class="my-2">{{step.cost}}</h2>
                                </span>
                            </div>
                            <div v-if="step.how_to_guide.service" class="card-footer border-0 cursor-pointer step-footer pt-0">
                                <div v-for="(statement, index) in step.how_to_guide.service.statements" :key="index">
                                    <hr class="my-0">
                                    <p class="my-2 text-brown">{{ statement.body }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="wrapper mt-3" v-if="showingDirections">
                            <print-direction v-for="(direction, index) in directions" :key="index" :direction="direction" :type="step.type">
                            </print-direction>
                        </div>
                    </div>
                </div>
                <div v-if="showAs === 'custom'" class="col-10 pl-0">
                    <div class="details">
<!--                         <div class="hour col-4 pl-0 d-lg-none">
                            <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                                <svg-icon name="clock" width="15" color="black"/>
                                <span class="align-self-center ml-1">{{departure}}</span>
                            </div>
                        </div> -->
                        <div class="card mt-2 bg-primary">
                            <div class="card-body">
                                <h2 class="text-white">{{ step.end_address }}</h2>
                                <h2 class="text-white mt-3 fw-normal">{{ step.description }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showAs === 'collapse'" class="col-10 d-flex pl-0">
                    <div class="col-3 pl-0 d-lg-none">
                        <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                            <span class="align-self-center ml-1">{{ step.step_count }}</span>
                        </div>
                    </div>
                    <button @click="emitShow" type="button" class="btn btn-outline-dark">Show instructions</button>
                </div>
                <div v-if="position !== 'last'" class="col-2 overflow-hidden position-relative h-1">
                    <div class="vertical-line print-step-vertical-line position-absolute"></div>
                </div>
            </div>
            <div v-if="step.directions && !showingDirections" class="row step">
                <div class="col-2 overflow-hidden position-relative">
                    <div class="time d-flex align-items-center justify-content-end">
                        <div class="hour d-none d-lg-block">
                            <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                                <span class="align-self-center ml-1">+{{ step.directions.length }}</span>
                            </div>
                        </div>
                        <div class="circle-icon ml-2 cursor-pointer bg-white">
                            <svg-icon name="three-dots" class="circle-icon-svg" height="auto" width="20"/>
                        </div>
                    </div>
                    <div class="vertical-line print-step-vertical-line position-absolute"></div>
                </div>
                <div class="col-10 d-flex pl-0">
                    <div class="col-3 pl-0 d-lg-none">
                        <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                            <span class="align-self-center ml-1">{{ step.directions.length }}</span>
                        </div>
                    </div>
                    <button @click="showingDirections = true" type="button" class="btn btn-outline-dark">Show instructions</button>
                </div>
                <div class="col-2 overflow-hidden position-relative h-1">
                    <div class="vertical-line position-absolute"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import PrintDirection from '@/components/PrintDirection.vue'

export default {
    props: ['step', 'showAs', 'position', 'journey', 'hours'],
    components: {
        PrintDirection,
    },
    data() {
        return {
            showingDirections: true,
        }
    },
    computed: {
        directions() {
            const directions = []
            if (this.step.directions) {
                const directionsLength = this.step.directions.length
                for (let i = 0; i < directionsLength; i += 1) {
                    const direction = this.step.directions[i]
                    const isLastdirection = directionsLength === (i + 1)
                    const position = isLastdirection ? 'last' : 'middle'

                    directions.push({
                        show_as: 'direction',
                        direction,
                        position,
                        journey_type: 'depart',
                    })
                }

                return directions
            }
            return directions
        },
        duration() {
            return moment.duration(this.step.duration.value, 'seconds')
        },
        icon() {
            return this.step.type
        },
        departure() {
            if (!this.step.departure_time && this.step.end_address === 'Return home') {
                return this.journey.return.arrival_at
            }
            if (!this.step.departure_time && this.step.end_address === 'Attend appointment') {
                return this.hours.value
            }
            return this.step.departure_time
        },
    },
    methods: {
        emitShow() {
            this.$emit('show')
        },
        showDetails() {
            this.$emit('showDetails')
        },

    },
}
</script>
